/**
 * border-radius options: https://www.figma.com/file/1AvCVJdBZRAVYsB5H0vFkC/YME-Design-System?node-id=916%3A19089
 *
 * @param xxs '2px',
 * @param xs '4px',
 * @param s '6px',
 * @param m '8px',
 * @param l '12px',
 * @param xl '16px',
 * @param xxl '20px',
 * @param none '0px',
 */
export const CORNER_RADIUS = {
    xxs: '2px',
    xs: '4px',
    s: '6px',
    m: '8px',
    l: '12px',
    xl: '16px',
    xxl: '20px',
    none: '0px',
    circle: '100%',
};
